import type { ReactNode } from "react";
import { CloudAuthProvider, useCloudAuthState } from "../../hooks/useCloudAuth";

interface CloudAuthWrapperProps {
  children: ReactNode;
}

export function CloudAuthWrapper({ children }: CloudAuthWrapperProps) {
  const authState = useCloudAuthState();

  return <CloudAuthProvider value={authState}>{children}</CloudAuthProvider>;
}
